var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BUSINESS_SERVER_ENDPOINT } from "App";
/**
 * Fetch a fee breakdown for an amount.
 *
 * The backend returns decimal strings; they are passed through untouched so no
 * precision is lost on amounts with up to 6 decimal places.
 */
export var fetchFee = function (_a) { return __awaiter(void 0, [_a], Promise, function (_b) {
    var query, response, errorData, data;
    var sessionToken = _b.sessionToken, assetCode = _b.assetCode, amount = _b.amount, feeMode = _b.feeMode, operation = _b.operation, signal = _b.signal;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                query = new URLSearchParams({
                    asset_code: assetCode,
                    amount: amount,
                    fee_mode: feeMode,
                });
                if (operation) {
                    query.set("operation", operation);
                }
                return [4 /*yield*/, fetch("".concat(BUSINESS_SERVER_ENDPOINT, "/fee?").concat(query.toString()), {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer ".concat(sessionToken),
                            "Content-Type": "application/json",
                        },
                        signal: signal,
                    })];
            case 1:
                response = _c.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json().catch(function () { return ({}); })];
            case 2:
                errorData = _c.sent();
                throw new Error(errorData.message ||
                    errorData.error ||
                    "Fee lookup failed: ".concat(response.status, " ").concat(response.statusText));
            case 3: return [4 /*yield*/, response.json()];
            case 4:
                data = (_c.sent());
                if (!data.amount_in || !data.amount_out || !data.amount_fee) {
                    throw new Error("Fee lookup returned an incomplete quote.");
                }
                return [2 /*return*/, {
                        amount_in: String(data.amount_in),
                        amount_out: String(data.amount_out),
                        amount_fee: String(data.amount_fee),
                        fee_mode: data.fee_mode || feeMode,
                        asset_code: String(data.asset_code || assetCode),
                    }];
        }
    });
}); };
